import { useEffect, useState } from "react";
import { get_estados_notificaciones } from "../../../actions";
import { SelectUi } from "../../ui";

export const EstadosNotificacionSelect = ({ ...props }) => {
  const [opciones, setOpciones] = useState([]);

  useEffect(() => {
    const OnLoad = async () => {
      const datos = await get_estados_notificaciones();
      setOpciones(datos);
    };
    OnLoad();
  }, []);

  return <SelectUi data={opciones} {...props} />;
};
